import { useState } from "react";
import { useAdmin } from "../../../context/admin";
import GeneralInput from "../../common/GeneralInput";
import Modal from "../../common/Modal";
import { AiOutlineCloseCircle } from "react-icons/ai";
import AdminService from "../../../services/admin.service";
import { useGlobal } from "../../../context/global";

export default function EditTraspassAmount() {
    const { setMessage } = useGlobal()
    const { editTraspassAmountReservationId, setEditTraspassAmountReservationId } = useAdmin()
    const [newData, setNewData] = useState({
        traspass_price: 0,
        tickets: 0
    })

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            await AdminService.editTraspassAmount(editTraspassAmountReservationId!, newData.traspass_price, newData.tickets)
            window.location.reload()
        } catch (error) {
            console.log(error)
            setMessage({
                type: 'error',
                content: 'Error updating traspass amount'
            })
        } finally {
            setTimeout(() => setMessage(undefined), 5000)
        }
    }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Edit Traspass Amount</h1>
            <GeneralInput
                label="New Traspass Price"
                type="number"
                value={newData.traspass_price}
                onChange={(e) => setNewData(prev => ({...prev, traspass_price: Number(e.target.value)}))}
                style={{marginBottom: '1rem'}}
            />
            <GeneralInput
                label="New Tickets Amount"
                type="number"
                value={newData.tickets}
                onChange={(e) => setNewData(prev => ({...prev, tickets: Number(e.target.value)}))}
            />
            <div className="actions"
            style={{display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1rem'}}
            >
                <button>Update</button>
            </div>
            <div className="close" title="close"
                onClick={() => setEditTraspassAmountReservationId(undefined)}
                >
                    <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}